<template>
  <div>
    <div class="w-full h-full flex flex-col gap-5">
      <div class="flex items-center justify-between">
        <div class="flex flex-col md:flex-row justify-between w-full">
          <h1 class="text-xl font-semibold">
            User Instructions
            <span class="text-[16px]"> ({{ count_list || 0 }})</span>
          </h1>
           <div class="flex justify-end">
              <div class="relative w-full md:max-w-80">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  v-model="search_list"
                  @input="getSyllabus(1)"
                  placeholder="Search..."
                  class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
                <button
                  v-if="search_list"
                  @click="clearSearch"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400 hover:text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
        </div>
      </div>
      <div>
        <div class="w-full flex flex-col gap-5" v-if="syllabus_list.length > 0">
          <div
            class="w-full bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
          >
            <table class="min-w-full">
              <thead>
                <tr
                  class="text-left bg-gray-100 text-textblues whitespace-nowrap text-sm capitalize"
                >
                  <th class="px-4 py-3 border-b border-r">S.No</th>
                  <th class="px-4 py-3 border-b border-r">Title</th>
                  <th class="px-4 py-3 border-b border-r">Year</th>
                  <th class="px-4 py-3 border-b border-r">PDF</th>
                  <th class="px-4 py-3 border-b border-r">Comments</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(list, index) in syllabus_list"
                  :key="index"
                  class="border-b pb-3 w-full cursor-pointer hover:bg-gray-50 text-sm"
                >
                  <td class="px-4 py-3 border-b border-r text-gray-500">
                    {{ (currentPage - 1) * pageSize + index + 1 }}
                  </td>
                  <td class="px-4 py-3 border-b border-r text-gray-800">
                    {{ list.title }}
                  </td>
                  <td class="px-4 py-3 border-b border-r">
                    {{ list.years }}
                  </td>
                  <td class="px-4 py-3 border-b border-r text-gray-500">
                    <a :href="list.pdf" target="_blank" class="text-textblues">{{
                      list.pdf?.split("/")?.pop() || "-"
                    }}</a>
                  </td>
                  <td class="px-4 py-3 border-b border-r text-gray-500">
                    {{ list.command }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
          >
            <!-- PAGE SIZE -->
            <div
              class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
            >
              <span class="flex md:hidden">Rows per page:</span>
              <select
                v-model="pageSize"
                @change="onPageSizeChange"
                class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>

            <!-- PAGINATION -->
            <div v-if="totalPages > 1" class="flex justify-center">
              <Pagination
                :totalPages="totalPages"
                ref="paginationRef"
                @page-changed="getSyllabus"
              />
            </div>
          </div>
        </div>
        <div v-else>
          <div
            class="flex flex-col items-center justify-center gap-4 py-16 px-4"
          >
            <div class="bg-gray-50 rounded-full p-6">
              <svg
                class="w-16 h-16 text-gray-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div class="text-center">
              <h3 class="text-gray-600 text-lg font-semibold mb-1">
                No instruction available
              </h3>
              <p class="text-gray-400 text-sm">
                Get started by creating a new instruction
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: true,
      syllabus_list: [],
      currentPage: 1,
      totalPages: 1,
       pageSize: 10,
      search_list: "",
      count_list: "",
      disable_submit: false,
    };
  },
  components: {},
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {},
  created() {
    this.getSyllabus(1);
  },
  methods: {
      clearSearch() {
      this.search_list = "";
      this.getSyllabus(1);
    },
     onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getSyllabus(1);
    },
    async getSyllabus(page) {
       this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/syllabus-overall-list/?page=${page}&search=${this.search_list}&page_size=${this.pageSize}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalPages = response.data.total_page;
            this.syllabus_list = response.data.data.data;
            this.count_list = response.data.total;
            this.loading = false;
            this.disable_submit = false;
          } else {
            console.log("got error");
            this.disable_submit = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style></style>
